import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logoImg from '../assets/442-numbers.png';
import {
  GridWrapper,
  Block,
  Home,
  LogoImage,
  BottomLeftRow,
  BottomRightRow,
  LogoContainer,
  TooltipOverlay,
} from '../styles/HomepageStyles';

const Homepage = () => {
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    // Restore default cursor
    document.body.style.cursor = 'auto';
  }, []);

  useEffect(() => {
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (window.innerWidth > 768 && showTooltip) {
          setShowTooltip(false);
        }
      }, 150);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(resizeTimeout);
    }
  }, [showTooltip]);

  const toggleTooltip = useCallback(() => {
    setShowTooltip((prev) => !prev);
  }, []);

  return (
    <>
      <GridWrapper>
          <Home>
            <LogoContainer onClick={toggleTooltip}>
              <Link to="/">
                <LogoImage src={logoImg} alt="Studio 442 Logo" />
              </Link>
              <TooltipOverlay show={showTooltip}>
                <p>We are Studio 442, creating architecture and art with love and detail.</p>
              </TooltipOverlay>
            </LogoContainer>
          </Home>

          <BottomLeftRow>
            <Block>
              <Link to="/art" style={{ textDecoration: 'none', color: 'inherit' }}>
                Art
              </Link>
            </Block>
            <Block>
              <Link to="/shop" style={{ textDecoration: 'none', color: 'inherit' }}>
                Shop
              </Link>
            </Block>
          </BottomLeftRow>


        {/* Right Side */}
          <Block style={{
            gridColumn: '3 / 5',
            gridRow: '1 / 4'
          }}>
            <Link
              to="/architecture"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              Architecture
            </Link>
          </Block>

          <Block style={{
            gridColumn: '3 / 5',
            gridRow: '4 / 7'
          }}>
            <Link
              to="/furniture"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              Furniture
            </Link>
          </Block>

          <BottomRightRow>
            <Block >
              <Link to="/events" style={{ textDecoration: 'none', color: 'inherit' }}>
                Events
              </Link>
            </Block>
            <Block>
              <Link to="/contact" style={{ textDecoration: 'none', color: 'inherit' }}>
                Contact
              </Link>
            </Block>
          </BottomRightRow>
      </GridWrapper>
    </>
  );
};

export default Homepage;